import { r as o, h as t } from "./index-6e735f92.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
const e = ".sc-forward-icon-h{display:flex}", i = e, s = class {
  constructor(r) {
    o(this, r), this.width = "15", this.height = "15";
  }
  render() {
    return t("svg", { key: "f093412278453f9ea9dc6cf345d6171c134a5398", fill: "auto", width: this.width, height: this.height, viewBox: "0 0 1920 1920", xmlns: "http://www.w3.org/2000/svg" }, t("path", { key: "f90de705f64444d7a2ad7fe7835a3e9af196a902", d: "m1246.246 64-90.496 90.496 477.952 477.952h-590.848C467.878 632.448.038 1100.416.038 1675.392v109.056h128v-109.056c0-504.576 410.368-914.944 914.816-914.944h590.848l-477.952 478.08 90.496 90.496 632.448-632.576L1246.246 64Z", "fill-rule": "evenodd" }));
  }
};
s.style = i;
export {
  s as forward_icon
};
